export const setExpandedItems = (expandedItems) => ({
  type: 'SET_EXPANDED_ITEMS',
  payload: expandedItems,
});
